// -- import * as _ from "lodash-es"
import * as api from "../../shared/api"
import * as biz_data_helper from "../../shared/biz_data_helper"

const content_type = "SalesLine"

const create = function () {
  return {
    content_type: "muji",
    age: 29
  }
}
const fields = {
  default: [
    {
      key: "AccountNum",
      label: "供应商编号",
      sortable: true
    },
    {
      key: "SEI_Name",
      label: "供应商名称",
      sortable: true,
      thStyle: {
        width: "11rem"
      }
    },
    {
      key: "ItemId",
      label: "物料编号",
      sortable: true
    },
    {
      key: "NameAlias",
      label: "物料名称",
      sortable: true,
      type: "short",
      width: "10rem"
    },
    {
      key: "VariantName",
      label: "变型名称",
      sortable: true,
      type: "short",
      width: "8rem"
    },
    {
      key: "qty",
      label: "数量",
      sortable: true,
      type: "number",
      _precise: 6
    },
    {
      key: "Cost_Sum",
      label: "成本",
      type: "number",
      _precise: 6
    },
    {
      key: "price",
      label: "报价",
      sortable: true,
      type: "number",
      _precise: 6
    },
    {
      key: "Capacity",
      label: "产能(天)",
      sortable: true,
      type: "number"
    },
    {
      key: "delivery_date",
      label: "装运日期",
      sortable: true,
      type: "date"
    },
    {
      key: "RetailVariantId",
      label: "变形编号",
      sortable: true,
      thStyle: {
        display: "none"
      },
      tdClass: "no-shown-RetailVariantId"
    },

    {
      key: "TotalScore",
      label: "评价",
      sortable: true,
      type: "rate",
      disabled: true,
      thStyle: {
        width: "10rem"
      }
    },
    {
      key: "create_at",
      label: "派单时间",
      sortable: true,
      type: "datetime"
    }
  ]
}

///前端验证
const rules = {}

const descriptor = {}
const methods = {
  ///get 派单详情
  async getData(_params) {
    let item_biz_data = new biz_data_helper.base_entity_helper(
      "sPlant_SalesOrder_Dispatch",
      {},
      {}
    )
    let _fields = _.map(fields.default, "key")
    _fields.push("id")
    _fields.push("SalesLineId")
    _fields.push("approved_at")
    let result = await item_biz_data
      .selectAction({
        params: _params,
        fields: _fields
      })
      .run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  }
}

const biz_data = new biz_data_helper.base_entity_helper(
  content_type,
  create,
  descriptor
)
export { methods, fields, rules, biz_data }
